<mat-card>
  <mat-card-title class="!flex flex-row justify-between items-center">
    <span data-at-diagnosis-explanation-title>{{ data.diagnosisTitleKey | translate }}</span>
    <button mat-icon-button mat-dialog-close data-at-diagnosis-explanation-close>
      <mat-icon>clear</mat-icon>
    </button>
  </mat-card-title>

  <mat-card-content>
    <ng-container *ngIf="isLoading$ | async; else explanation">
      <vi-loader
        body
        [isLoading]="true"
        titleKey=""
        message="{{ '+REMOTE_SERVICE.DIAGNOSIS_EXPLANATION.ANALYZING' | translate }}"
      ></vi-loader>
    </ng-container>

    <ng-template #explanation>
      <ng-container *ngIf="explanation$ | async as explanation; else noExplanation">
        <p class="explanation-text" data-at-diagnosis-explanation-text>
          {{ explanation.explanation }}
        </p>
      </ng-container>
    </ng-template>

    <ng-template #noExplanation>
      <app-banner type="info">
        {{ '+REMOTE_SERVICE.DIAGNOSIS_EXPLANATION.NOT_AVAILABLE' | translate }}
      </app-banner>
    </ng-template>
  </mat-card-content>
</mat-card>
